// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"371":"d1a937a5","790":"f911de74"}[chunkId] + ".js";
};